import React from "react";
import { Link } from "react-router-dom";

const CreatorSection: React.FC = () => {
  return (
    <div className="section section_07" id="section_07">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col_right">
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/creator_image.png?v=2"
              className="img-fluid"
              alt="Flangoo Price Grid"
            />
          </div>
          <div className="col-md-5 col-md-offset-1">
            <img
              src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/FlangooWHITECreatorLONG.png"
              className="img-fluid"
              alt="Flangoo Creator Logo"
            />
            <h2 className="text-left mb-0">
              New! Publish your own writings and stories with Flangoo Creator™
            </h2>
            <p className="mt-2">
              Take all those things you’ve created, anything your students have
              written, and with your permission, add them to your Flangoo
              Library. Flangoo creator also allows for the addition of audio,
              pictures, hover-over vocab, and comprehension quizzes. It’s as
              simple as using Microsoft Word or Google Docs. You also have the
              option to share your content with other teachers as they share
              theirs with you. All the while, you still control what you want
              your students to read!
            </p>
            <Link to="/creator" className="btn btn-primary mt-5 ">
              {" "}
              Click here to learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatorSection;
